function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "enterBG"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 232.4,
  cy: 232.4,
  r: 226.9
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "enterT"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M262.1,38.2l8.7-9.6c2-2.2,0.9-5.8-2.1-6.5L256,19.3c-3-0.6-5.5,2.2-4.6,5l4,12.4 C256.3,39.6,260,40.4,262.1,38.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M311.3,52.5l10.9-7.1c2.5-1.6,2.3-5.4-0.3-6.8l-11.6-5.9c-2.7-1.4-5.9,0.7-5.7,3.7l0.7,13 C305.4,52.4,308.8,54.1,311.3,52.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M355.2,79l12.4-4c2.9-0.9,3.7-4.6,1.4-6.7l-9.6-8.7c-2.2-2-5.8-0.9-6.5,2.1l-2.7,12.7 C349.5,77.4,352.3,80,355.2,79z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M390.7,116l13-0.7c3-0.2,4.7-3.5,3.1-6.1l-7.1-10.9c-1.6-2.5-5.4-2.3-6.8,0.3l-5.9,11.6 C385.6,113,387.7,116.2,390.7,116z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M415.4,161l12.7,2.7c3,0.6,5.5-2.2,4.6-5l-4-12.4c-0.9-2.9-4.6-3.7-6.7-1.4l-8.7,9.6 C411.3,156.8,412.5,160.4,415.4,161z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M427.7,210.8l11.6,5.9c2.7,1.4,5.9-0.7,5.7-3.7l-0.7-13c-0.2-3-3.5-4.7-6.1-3.1l-10.9,7.1 C424.8,205.6,425,209.4,427.7,210.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M426.6,262.1l9.6,8.7c2.2,2,5.8,0.9,6.5-2.1l2.7-12.7c0.6-3-2.2-5.5-5-4.6l-12.4,4 C425.1,256.3,424.3,260,426.6,262.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M412.3,311.3l7.1,10.9c1.6,2.5,5.4,2.3,6.8-0.3l5.9-11.6c1.4-2.7-0.7-5.9-3.7-5.7l-13,0.7 C412.4,305.4,410.6,308.8,412.3,311.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M385.7,355.2l4,12.4c0.9,2.9,4.6,3.7,6.7,1.4l8.7-9.6c2-2.2,0.9-5.8-2.1-6.5l-12.7-2.7 C387.3,349.5,384.8,352.3,385.7,355.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M348.7,390.7l0.7,13c0.2,3,3.5,4.7,6.1,3.1l10.9-7.1c2.5-1.6,2.3-5.4-0.3-6.8l-11.6-5.9 C351.7,385.6,348.6,387.7,348.7,390.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M303.8,415.4l-2.7,12.7c-0.6,3,2.2,5.5,5,4.6l12.4-4c2.9-0.9,3.7-4.6,1.4-6.7l-9.6-8.7 C308,411.3,304.4,412.5,303.8,415.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M254,427.7l-5.9,11.6c-1.4,2.7,0.7,5.9,3.7,5.7l13-0.7c3-0.2,4.7-3.5,3.1-6.1l-7.1-10.9 C259.1,424.8,255.4,425,254,427.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M202.7,426.6l-8.7,9.6c-2,2.2-0.9,5.8,2.1,6.5l12.7,2.7c3,0.6,5.5-2.2,4.6-5l-4-12.4 C208.4,425.1,204.7,424.3,202.7,426.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M153.5,412.3l-10.9,7.1c-2.5,1.6-2.3,5.4,0.3,6.8l11.6,5.9c2.7,1.4,5.9-0.7,5.7-3.7l-0.7-13 C159.4,412.4,156,410.6,153.5,412.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M109.6,385.7l-12.4,4c-2.9,0.9-3.7,4.6-1.4,6.7l9.6,8.7c2.2,2,5.8,0.9,6.5-2.1l2.7-12.7 C115.3,387.3,112.5,384.8,109.6,385.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M74.1,348.7l-13,0.7c-3,0.2-4.7,3.5-3.1,6.1l7.1,10.9c1.6,2.5,5.4,2.3,6.8-0.3l5.9-11.6 C79.1,351.7,77.1,348.6,74.1,348.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M49.4,303.8l-12.7-2.7c-3-0.6-5.5,2.2-4.6,5l4,12.4c0.9,2.9,4.6,3.7,6.7,1.4l8.7-9.6 C53.5,308,52.3,304.4,49.4,303.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M37.1,254l-11.6-5.9c-2.7-1.4-5.9,0.7-5.7,3.7l0.7,13c0.2,3,3.5,4.7,6.1,3.1l10.9-7.1 C40,259.1,39.8,255.4,37.1,254z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M38.2,202.7l-9.6-8.7c-2.2-2-5.8-0.9-6.5,2.1l-2.7,12.7c-0.6,3,2.2,5.5,5,4.6l12.4-4 C39.6,208.4,40.4,204.7,38.2,202.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M52.5,153.5l-7.1-10.9c-1.6-2.5-5.4-2.3-6.8,0.3l-5.9,11.6c-1.4,2.7,0.7,5.9,3.7,5.7l13-0.7 C52.4,159.4,54.1,156,52.5,153.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M79,109.6l-4-12.4c-0.9-2.9-4.6-3.7-6.7-1.4l-8.7,9.6c-2,2.2-0.9,5.8,2.1,6.5l12.7,2.7 C77.4,115.3,80,112.5,79,109.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M116,74.1l-0.7-13c-0.2-3-3.5-4.7-6.1-3.1l-10.9,7.1c-2.5,1.6-2.3,5.4,0.3,6.8l11.6,5.9 C113,79.1,116.2,77.1,116,74.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M161,49.4l2.7-12.7c0.6-3-2.2-5.5-5-4.6l-12.4,4c-2.9,0.9-3.7,4.6-1.4,6.7l9.6,8.7 C156.8,53.5,160.4,52.3,161,49.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M210.8,37.1l5.9-11.6c1.4-2.7-0.7-5.9-3.7-5.7l-13,0.7c-3,0.2-4.7,3.5-3.1,6.1l7.1,10.9 C205.6,40,209.4,39.8,210.8,37.1z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "enterFT"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M229,20.2l-12.8,22.2c-1.5,2.6,0.4,5.9,3.4,5.9h25.6c3,0,4.9-3.3,3.4-5.9l-12.8-22.2 C234.3,17.6,230.5,17.6,229,20.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M284,26.6l-18.1,18.1c-2.1,2.1-1.2,5.8,1.8,6.6l24.7,6.6c2.9,0.8,5.6-1.9,4.8-4.8l-6.6-24.7 C289.8,25.4,286.2,24.4,284,26.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M335.5,46.9l-22.2,12.8c-2.6,1.5-2.6,5.3,0,6.8l22.2,12.8c2.6,1.5,5.9-0.4,5.9-3.4V50.3 C341.4,47.3,338.1,45.4,335.5,46.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M380,79.9l-24.7,6.6c-2.9,0.8-3.9,4.4-1.8,6.6l18.1,18.1c2.1,2.1,5.8,1.2,6.6-1.8l6.6-24.7 C385.6,81.8,382.9,79.2,380,79.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M414.4,123.3h-25.6c-3,0-4.9,3.3-3.4,5.9l12.8,22.2c1.5,2.6,5.3,2.6,6.8,0l12.8-22.2 C419.4,126.6,417.5,123.3,414.4,123.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M436.5,174.2l-24.7-6.6c-2.9-0.8-5.6,1.9-4.8,4.8l6.6,24.7c0.8,2.9,4.4,3.9,6.6,1.8l18.1-18.1 C440.4,178.6,439.4,175,436.5,174.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M444.6,229l-22.2-12.8c-2.6-1.5-5.9,0.4-5.9,3.4v25.6c0,3,3.3,4.9,5.9,3.4l22.2-12.8 C447.2,234.3,447.2,230.5,444.6,229z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M438.2,284l-18.1-18.1c-2.1-2.1-5.8-1.2-6.6,1.8l-6.6,24.7c-0.8,2.9,1.9,5.6,4.8,4.8l24.7-6.6 C439.4,289.8,440.4,286.2,438.2,284z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M417.8,335.5L405,313.4c-1.5-2.6-5.3-2.6-6.8,0l-12.8,22.2c-1.5,2.6,0.4,5.9,3.4,5.9h25.6 C417.5,341.4,419.4,338.1,417.8,335.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M384.8,380l-6.6-24.7c-0.8-2.9-4.4-3.9-6.6-1.8l-18.1,18.1c-2.1,2.1-1.2,5.8,1.8,6.6l24.7,6.6 C382.9,385.6,385.6,382.9,384.8,380z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M341.4,414.4v-25.6c0-3-3.3-4.9-5.9-3.4l-22.2,12.8c-2.6,1.5-2.6,5.3,0,6.8l22.2,12.8 C338.1,419.4,341.4,417.5,341.4,414.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M290.6,436.5l6.6-24.7c0.8-2.9-1.9-5.6-4.8-4.8l-24.7,6.6c-2.9,0.8-3.9,4.4-1.8,6.6l18.1,18.1 C286.2,440.4,289.8,439.4,290.6,436.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M235.8,444.6l12.8-22.2c1.5-2.6-0.4-5.9-3.4-5.9h-25.6c-3,0-4.9,3.3-3.4,5.9l12.8,22.2 C230.5,447.2,234.3,447.2,235.8,444.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M180.8,438.2l18.1-18.1c2.1-2.1,1.2-5.8-1.8-6.6l-24.7-6.6c-2.9-0.8-5.6,1.9-4.8,4.8l6.6,24.7 C175,439.4,178.6,440.4,180.8,438.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M129.2,417.8l22.2-12.8c2.6-1.5,2.6-5.3,0-6.8l-22.2-12.8c-2.6-1.5-5.9,0.4-5.9,3.4v25.6 C123.3,417.5,126.6,419.4,129.2,417.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M84.8,384.8l24.7-6.6c2.9-0.8,3.9-4.4,1.8-6.6l-18.1-18.1c-2.1-2.1-5.8-1.2-6.6,1.8L79.9,380 C79.2,382.9,81.8,385.6,84.8,384.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M50.3,341.4h25.6c3,0,4.9-3.3,3.4-5.9l-12.8-22.2c-1.5-2.6-5.3-2.6-6.8,0l-12.8,22.2 C45.4,338.1,47.3,341.4,50.3,341.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M28.3,290.6l24.7,6.6c2.9,0.8,5.6-1.9,4.8-4.8l-6.6-24.7c-0.8-2.9-4.4-3.9-6.6-1.8L26.6,284 C24.4,286.2,25.4,289.8,28.3,290.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M20.2,235.8l22.2,12.8c2.6,1.5,5.9-0.4,5.9-3.4v-25.6c0-3-3.3-4.9-5.9-3.4L20.2,229 C17.6,230.5,17.6,234.3,20.2,235.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M26.6,180.8l18.1,18.1c2.1,2.1,5.8,1.2,6.6-1.8l6.6-24.7c0.8-2.9-1.9-5.6-4.8-4.8l-24.7,6.6 C25.4,175,24.4,178.6,26.6,180.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M46.9,129.2l12.8,22.2c1.5,2.6,5.3,2.6,6.8,0l12.8-22.2c1.5-2.6-0.4-5.9-3.4-5.9H50.3 C47.3,123.3,45.4,126.6,46.9,129.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M79.9,84.8l6.6,24.7c0.8,2.9,4.4,3.9,6.6,1.8l18.1-18.1c2.1-2.1,1.2-5.8-1.8-6.6l-24.7-6.6 C81.8,79.2,79.2,81.8,79.9,84.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M123.3,50.3v25.6c0,3,3.3,4.9,5.9,3.4l22.2-12.8c2.6-1.5,2.6-5.3,0-6.8l-22.2-12.8 C126.6,45.4,123.3,47.3,123.3,50.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M174.2,28.3L167.6,53c-0.8,2.9,1.9,5.6,4.8,4.8l24.7-6.6c2.9-0.8,3.9-4.4,1.8-6.6l-18.1-18.1 C178.6,24.4,175,25.4,174.2,28.3z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "enterTGray"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M262.1,38.2l8.7-9.6c2-2.2,0.9-5.8-2.1-6.5L256,19.3c-3-0.6-5.5,2.2-4.6,5l4,12.4 C256.3,39.6,260,40.4,262.1,38.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M311.3,52.5l10.9-7.1c2.5-1.6,2.3-5.4-0.3-6.8l-11.6-5.9c-2.7-1.4-5.9,0.7-5.7,3.7l0.7,13 C305.4,52.4,308.8,54.1,311.3,52.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M355.2,79l12.4-4c2.9-0.9,3.7-4.6,1.4-6.7l-9.6-8.7c-2.2-2-5.8-0.9-6.5,2.1l-2.7,12.7 C349.5,77.4,352.3,80,355.2,79z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M390.7,116l13-0.7c3-0.2,4.7-3.5,3.1-6.1l-7.1-10.9c-1.6-2.5-5.4-2.3-6.8,0.3l-5.9,11.6 C385.6,113,387.7,116.2,390.7,116z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M415.4,161l12.7,2.7c3,0.6,5.5-2.2,4.6-5l-4-12.4c-0.9-2.9-4.6-3.7-6.7-1.4l-8.7,9.6 C411.3,156.8,412.5,160.4,415.4,161z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M427.7,210.8l11.6,5.9c2.7,1.4,5.9-0.7,5.7-3.7l-0.7-13c-0.2-3-3.5-4.7-6.1-3.1l-10.9,7.1 C424.8,205.6,425,209.4,427.7,210.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M426.6,262.1l9.6,8.7c2.2,2,5.8,0.9,6.5-2.1l2.7-12.7c0.6-3-2.2-5.5-5-4.6l-12.4,4 C425.1,256.3,424.3,260,426.6,262.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M412.3,311.3l7.1,10.9c1.6,2.5,5.4,2.3,6.8-0.3l5.9-11.6c1.4-2.7-0.7-5.9-3.7-5.7l-13,0.7 C412.4,305.4,410.6,308.8,412.3,311.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M385.7,355.2l4,12.4c0.9,2.9,4.6,3.7,6.7,1.4l8.7-9.6c2-2.2,0.9-5.8-2.1-6.5l-12.7-2.7 C387.3,349.5,384.8,352.3,385.7,355.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M348.7,390.7l0.7,13c0.2,3,3.5,4.7,6.1,3.1l10.9-7.1c2.5-1.6,2.3-5.4-0.3-6.8l-11.6-5.9 C351.7,385.6,348.6,387.7,348.7,390.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M303.8,415.4l-2.7,12.7c-0.6,3,2.2,5.5,5,4.6l12.4-4c2.9-0.9,3.7-4.6,1.4-6.7l-9.6-8.7 C308,411.3,304.4,412.5,303.8,415.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M254,427.7l-5.9,11.6c-1.4,2.7,0.7,5.9,3.7,5.7l13-0.7c3-0.2,4.7-3.5,3.1-6.1l-7.1-10.9 C259.1,424.8,255.4,425,254,427.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M202.7,426.6l-8.7,9.6c-2,2.2-0.9,5.8,2.1,6.5l12.7,2.7c3,0.6,5.5-2.2,4.6-5l-4-12.4 C208.4,425.1,204.7,424.3,202.7,426.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M153.5,412.3l-10.9,7.1c-2.5,1.6-2.3,5.4,0.3,6.8l11.6,5.9c2.7,1.4,5.9-0.7,5.7-3.7l-0.7-13 C159.4,412.4,156,410.6,153.5,412.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M109.6,385.7l-12.4,4c-2.9,0.9-3.7,4.6-1.4,6.7l9.6,8.7c2.2,2,5.8,0.9,6.5-2.1l2.7-12.7 C115.3,387.3,112.5,384.8,109.6,385.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M74.1,348.7l-13,0.7c-3,0.2-4.7,3.5-3.1,6.1l7.1,10.9c1.6,2.5,5.4,2.3,6.8-0.3l5.9-11.6 C79.1,351.7,77.1,348.6,74.1,348.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M49.4,303.8l-12.7-2.7c-3-0.6-5.5,2.2-4.6,5l4,12.4c0.9,2.9,4.6,3.7,6.7,1.4l8.7-9.6 C53.5,308,52.3,304.4,49.4,303.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M37.1,254l-11.6-5.9c-2.7-1.4-5.9,0.7-5.7,3.7l0.7,13c0.2,3,3.5,4.7,6.1,3.1l10.9-7.1 C40,259.1,39.8,255.4,37.1,254z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M38.2,202.7l-9.6-8.7c-2.2-2-5.8-0.9-6.5,2.1l-2.7,12.7c-0.6,3,2.2,5.5,5,4.6l12.4-4 C39.6,208.4,40.4,204.7,38.2,202.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M52.5,153.5l-7.1-10.9c-1.6-2.5-5.4-2.3-6.8,0.3l-5.9,11.6c-1.4,2.7,0.7,5.9,3.7,5.7l13-0.7 C52.4,159.4,54.1,156,52.5,153.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M79,109.6l-4-12.4c-0.9-2.9-4.6-3.7-6.7-1.4l-8.7,9.6c-2,2.2-0.9,5.8,2.1,6.5l12.7,2.7 C77.4,115.3,80,112.5,79,109.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M116,74.1l-0.7-13c-0.2-3-3.5-4.7-6.1-3.1l-10.9,7.1c-2.5,1.6-2.3,5.4,0.3,6.8l11.6,5.9 C113,79.1,116.2,77.1,116,74.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M161,49.4l2.7-12.7c0.6-3-2.2-5.5-5-4.6l-12.4,4c-2.9,0.9-3.7,4.6-1.4,6.7l9.6,8.7 C156.8,53.5,160.4,52.3,161,49.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1gray",
  d: "M210.8,37.1l5.9-11.6c1.4-2.7-0.7-5.9-3.7-5.7l-13,0.7c-3,0.2-4.7,3.5-3.1,6.1l7.1,10.9 C205.6,40,209.4,39.8,210.8,37.1z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "incircle"
}, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M60.6,232.4c0-94.9,76.9-171.8,171.8-171.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M232.4,60.6c94.9,0,171.8,76.9,171.8,171.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M404.2,232.4c0,94.9-76.9,171.8-171.8,171.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M232.4,404.2c-94.9,0-171.8-76.9-171.8-171.8"
}));

var SvgEnterBg = function SvgEnterBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "enterBG",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464.8 464.8",
    style: {
      enableBackground: "new 0 0 464.8 464.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnterBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enterBG.3ed8b147.svg";
export { ForwardRef as ReactComponent };